export function setExamsAdded(examsAdded) {
  return {
    type: '@exams/SET_EXAMS_ADDED',
    examsAdded,
  };
}

export function setUploadExams(uploadExams) {
  return {
    type: '@exams/SET_UPLOAD_EXAMS',
    uploadExams,
  };
}
